import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { heroBackground } from '../data/photos';
import './Hero.css';

const titleVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.06, delayChildren: 0.2 },
  },
};

const letterVariants = {
  hidden: { y: '110%', opacity: 0 },
  visible: {
    y: '0%',
    opacity: 1,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

const AnimatedTitle = ({ text }) => (
  <motion.h1
    className="hero-title"
    variants={titleVariants}
    initial="hidden"
    animate="visible"
    aria-label={text}
  >
    {text.split('').map((char, i) => (
      <span className="hero-title-mask" key={i}>
        <motion.span className="hero-title-char" variants={letterVariants}>
          {char === ' ' ? '\u00A0' : char}
        </motion.span>
      </span>
    ))}
  </motion.h1>
);

const Hero = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start start', 'end start'],
  });

  const bgY = useTransform(scrollYProgress, [0, 1], ['0%', '30%']);
  const contentOpacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);
  const contentY = useTransform(scrollYProgress, [0, 1], ['0%', '20%']);

  return (
    <section id="hero" ref={containerRef} className="hero">
      <motion.div
        className="hero-bg"
        style={{
          backgroundImage: `url(${heroBackground})`,
          y: bgY,
        }}
      />
      <div className="hero-scrim" />
      <motion.div
        className="hero-content"
        style={{ opacity: contentOpacity, y: contentY }}
      >
        <AnimatedTitle text="Welcome To Flicks" />
        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          Scroll down to start
        </motion.p>
      </motion.div>
      <motion.div
        className="hero-scroll-cue"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4, duration: 0.6 }}
      >
        <motion.span
          className="hero-scroll-chevron"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
        />
      </motion.div>
    </section>
  );
};

export default Hero;
